module.exports = __webpack_public_path__ + "img/head60.f571d9b0.png";